import { SearchQuery } from "shared/data/reducers/types/storage";
import { RoomCategory } from "shared/types/hotels";

const filterRoomPrice = (searchQuery: SearchQuery) => (
  room: RoomCategory
): boolean => {
  const price = Number(room.PriceWithServiceFee);

  const min = searchQuery.lowestPrice
    ? Number(searchQuery.lowestPrice)
    : undefined;
  const max = searchQuery.highestPrice
    ? Number(searchQuery.highestPrice)
    : undefined;

  if (min !== undefined && price < min) {
    return false;
  }

  if (max !== undefined && price > max) {
    return false;
  }

  return true;
};

export default filterRoomPrice;
